<template>
    <section class="pb-0 pt-3" :class="classes" id="checkout-pricing-overview">
        <subscription-costs
            :currency="currency"
                :vehicle="vehicle"
                :subscription="subscription"
        ></subscription-costs>

        <spacer :with-hr="false"></spacer>

        <delivery-costs
            :currency="currency"
            :vehicle="vehicle"
            :subscription="subscription"
        ></delivery-costs>
    </section>
</template>

<script>
    export default {
        name: "PricingOverview",
        props: {
          currency: {
            type: String,
            default: "€"
          },
            vehicle: {
                type: Object,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            },
            classes: {
                type: String,
                required: false,
                default: "col-12 col-md-12"
            }
        },
    }
</script>

<style scoped>

</style>
